import apiConfig from "../config/api.config";

/** Full-page redirect URLs (API must have matching OAuth env and redirect URIs). */
export const OAUTH_GOOGLE_URL = `${apiConfig.BASE_URL}/auth/google/start`;
export const OAUTH_FACEBOOK_URL = `${apiConfig.BASE_URL}/auth/facebook/start`;
